import React from "react";
import UnemployedNavbar from "./UnemployedNavbar";

function UnemployedHome() {
    
    return(
        <>
        <UnemployedNavbar />
        <div className="card" style={{backgroundColor:'gainsboro',position:'relative',top:'50px'}}>
            <h2 >Unemployed Home</h2>
        </div>
        </>
    );
}
export default UnemployedHome;